<div class="content pos-relative m-lr-30 m-b-30 flex flex-col">
  <div class="keno-grid-container">
    <particle-virtual-grid [sourceKey]="sourceKey"
                           sortFieldKey="Header"
                           sortDirection="asc"
                           [invalidateSubject]="invalidateSubject"
                           (valueChanged)="onGridCellValueChange($event)">
    </particle-virtual-grid>
  </div>
</div>
